/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1029
 */

"use strict"

function r(e) {
  var t
  var n = arguments.length > 1 && undefined !== arguments[1] ? arguments[1] : 166
  function r() {
    for (var /* [auto-meaningful-name] */arguments$length = arguments.length, i = new Array(arguments$length), o = 0; o < arguments$length; o++) {
      i[o] = arguments[o]
    }
    var a = this
    var s = function () {
      e.apply(a, i)
    }
    clearTimeout(t)
    t = setTimeout(s, n)
  }
  r.clear = function () {
    clearTimeout(t)
  }
  return r
}
export { r as a }
export default r
